import { fetch } from "../lib/network";
import decamelizeKeys from "decamelize-keys";
import queryString from "query-string";
import AppSettings from "../config";

export const getSiteInfo = (networkHeaders: any) => (_: any, site: string) =>
  fetch(`${AppSettings.CITIZEN_API_URL}/sites/${site}`, {
    method: "GET",
    headers: networkHeaders,
  }).then((res) => res.json());

export const getCitizenSearch = (networkHeaders: any) => (body: any) =>
  fetch(`${AppSettings.CITIZENS_API_URL}/search`, {
    method: "POST",
    headers: networkHeaders,
    body: JSON.stringify(body),
  }).then((res) => res.json());

export const createUserAPI = (networkHeaders: any) => (body: any) =>
  fetch(`${AppSettings.CITIZENS_API_URL}`, {
    method: "POST",
    headers: networkHeaders,
    body: JSON.stringify({ data: { attributes: body } }),
  }).then((res) => res.json());

export const getCitizenByEmail = (networkHeaders: any, email: any) => () =>
  fetch(`${AppSettings.CITIZENS_API_URL}?email=${email}`, {
    method: "GET",
    headers: networkHeaders,
  }).then((res) => res.json());

export const getCitizenPermitsTypes = (networkHeaders: any) => () =>
  fetch(`${AppSettings.CITIZEN_API_URL}/permits/types`, {
    method: "GET",
    headers: networkHeaders,
  }).then((res) => res.json());

export const getCitizenPermitsType = (networkHeaders: any, userId: string) => (_: any, id: any) =>
  fetch(`${AppSettings.CITIZEN_API_URL}/permits/types/${id}${userId ? `?user_id=${userId}` : ""}`, {
    method: "GET",
    headers: networkHeaders,
  }).then((res) => res.json());

export const getCitizenPermits = (networkHeaders: any) => (_: any, query: any) =>
  fetch(`${AppSettings.CITIZEN_API_URL}/permits?${queryString.stringify(query, { arrayFormat: "bracket" })}`, {
    method: "GET",
    headers: networkHeaders,
  }).then((res) => res.json());

export const getCitizenPermitRenewal = (networkHeaders: any, id: number) => () =>
  fetch(`${AppSettings.PERMITS_API_URL}/${id}/renewal_data`, {
    method: "GET",
    headers: networkHeaders,
  }).then((res) => res.json());

export const postCitizenPermit = (networkHeaders: any, userId: any, parentId: any) => (body: any) => {
  let params = userId ? "?user_id=" + userId : "";
  if (params.length !== 0) {
    params += params + parentId ? "&parent_id=" + parentId : "";
  }
  return fetch(`${AppSettings.CITIZEN_API_URL}/permits${params}`, {
    method: "POST",
    headers: networkHeaders,
    body: JSON.stringify({ data: { attributes: decamelizeKeys(body, "-") } }),
  });
};

export const postCitizenCrmRequest = (networkHeaders: any) => (body: any) => {
  return fetch(`${AppSettings.CITIZEN_API_URL}/requests`, {
    method: "POST",
    headers: networkHeaders,
    body: JSON.stringify(body),
  }).then(async (res) => {
    const json = await res.json();
    if (res.ok) {
      return json;
    }
    throw json;
  });
};
